module.exports = __webpack_public_path__ + "static/media/FSL_logo.fce96455.png";